import { getComposeEvent } from 'owa-calendar-compose-store-manager';

export default function (formId: string): boolean {
    return getComposeEvent(formId).IsOnlineMeeting;
}
